(function () {
  'use strict';

  const BTN_SEL = '[data-oat-wishlist]';
  const OVERLAY_SEL = '[data-oat-tile-overlay]';

  function isLoggedIn() {
    return window.OATMEAL_IS_LOGGED_IN === true;
  }

  function getStore() {
    return window.OatmealWishlistStore || null;
  }

  function getWishlistMeta(btn) {
    const overlay = btn.closest(OVERLAY_SEL);
    if (!overlay) return null;

    const handle = (overlay.dataset.productHandle || overlay.getAttribute('data-product-handle') || '').trim();
    const color = (overlay.dataset.color || overlay.getAttribute('data-color') || '').trim();
    const productId = (overlay.dataset.productId || overlay.getAttribute('data-product-id') || '').trim();
    const variantId = (overlay.dataset.variantId || overlay.getAttribute('data-variant-id') || '').trim();
    const productUrl = (overlay.dataset.productUrl || overlay.getAttribute('data-product-url') || '').trim();

    const meta = { handle, color, productId, variantId, productUrl };
    if (!meta.handle && !meta.color && !meta.productId && !meta.variantId) return null;
    return meta;
  }

  function setPressed(btn, pressed) {
    btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
  }

  function syncButton(btn) {
    const store = getStore();
    if (!store) return;

    const meta = getWishlistMeta(btn);
    if (!meta) return;

    store.register?.(meta);
    setPressed(btn, store.has(meta));
  }

  function syncAll() {
    document.querySelectorAll(BTN_SEL).forEach(syncButton);
  }

  function onClickCapture(e) {
    const btn = e.target.closest(BTN_SEL);
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const store = getStore();
    if (!store) return;

    const meta = getWishlistMeta(btn);
    if (!meta) return;

    if (!isLoggedIn()) {
      window.OatmealAuthPromptOpen?.({ wishlistItem: meta });
      return;
    }

    store.register?.(meta);
    const active = store.has(meta);

    if (active) store.remove(meta);
    else store.add(meta);

    // optimistic UI (store dispatch will resync everything anyway)
    setPressed(btn, !active);
  }

  function mount() {
    // ONE handler only (capture), avoids double-toggling
    document.addEventListener('click', onClickCapture, true);

    window.addEventListener('oatmeal:wishlist:changed', syncAll);

    syncAll();
  }

  // Boot after DOM; store is already defer-loaded, but keep it safe
  function boot() {
    let tries = 0;
    (function waitForStore() {
      tries += 1;
      if (getStore()) return mount();
      if (tries < 120) return setTimeout(waitForStore, 50);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
